import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import appConfig from "../../config/appConfig";
import "../affiliate/affiliate.css";
import "./billing.css";

import MySubscriptions from "./MySubscriptions";
import MyTransactions from "./MyTransactions";
import MyEntitlements from "./MyEntitlements";

const AccountRouter = () => (
    <Routes>
        <Route path="/" element={<Navigate to="entitlements" replace />} />
        <Route path="/entitlements"  element={<><Sidebar /><MyEntitlements pageTitle={appConfig.pageTitle("My entitlements")} /></>} />
        <Route path="/subscriptions" element={<><Sidebar /><MySubscriptions pageTitle={appConfig.pageTitle("My subscriptions")} /></>} />
        <Route path="/transactions"  element={<><Sidebar /><MyTransactions pageTitle={appConfig.pageTitle("My transactions")} /></>} />
    </Routes>
);

export default AccountRouter;
